module.exports = __webpack_public_path__ + "img/5.b0645582.png";